import { ProfileService } from 'client/services';

const action = async ({ request }) => {
    if (request.method === 'DELETE') {
        const { bookmarkIds } = Object.fromEntries(await request.formData());
        if (bookmarkIds) {
            await ProfileService.deleteBookmarks(bookmarkIds);
            return { deleted: true };
        }
    }
    return {};
};

export default action;
